import moment from 'moment'

export default {
  computed: {
    /**
     * GIves available images for this mpe
     * @returns {Array}
     */
    getAvailableImages () {
      return this.availableMedia
    },

    /**
     * Gives selected images
     * @returns {Array}
     */
    getSelectedImages () {
      return this.selectedMedia
    },

    /**
     * Gives MPE's payload
     * @returns {Object}
     */
    getPayload () {
      return this.mpeFields
    }
  },

  methods: {
    /**
     * Emits event to update mpe params
     * @param {Object} e MPE param
     */
    updateMpeParams (e) {
      this.$emit('updateMpeParams', e)
    },
    
    /**
     * Emits event to save changes
     * @param {Object} e
     */
    saveChanges (e) {
      this.$emit('saveChanges', e)
    },
    
    /**
     * Emits event to duplicate MPE
     * @param {Object} e
     */
    duplicateMpe (e) {
      this.$emit('duplicateMpe', e)
    },
    
    /**
     * Emits event to discard changes done to the
     * @param {Object} e
     */
    discardChanges (e) {
      this.$emit('discardChanges', e)
    }
  },

  props: {
    mpeFields: {
      type: Object,
      required: true,
      default: () => { return {} }
    },
    preview: {
      type: Boolean,
      required: false,
      default: false
    },
    mpeStriped: {
      required: true,
      type: Object,
      default: () => ({})
    },
    availableMedia: {
      type: Array,
      required: false,
      default: () => []
    },
    selectedMedia: {
      type: Array,
      required: false,
      default: () => []
    },

    basic: {
      type: Boolean,
      required: false,
      default: false
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/campaigns/mpeEditor/formatterBase.js